import { defineMessages } from 'react-intl';

export default defineMessages({
  upload: 'Załącz obrazek',
  remove: 'Usuń obrazek',
  errorTypeFile: 'Niepoprawny format pliku',
  errorFileSize: 'Waga pliku jest zbyt duża',
});
